export type DateFormat = 'MMM D, yyyy'

export function formatDate(
  d: Date,
  format: DateFormat,
  locale = 'en-US'
): string {
  switch (format) {
    case 'MMM D, yyyy':
      return d.toLocaleDateString(locale, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      })
    default:
      throw new Error(`Unhandled date format "${format}"`)
  }
}
